/**
 * 브라우저 환경 감지. 특히 카톡 같은 **인앱 브라우저**를 알아채는 게 핵심이다 —
 * 인앱 웹뷰는 WebAuthn(패스키)·홈 화면 추가가 막히거나 불안정해서, 감지되면
 * "크롬·사파리로 열기"를 안내한다.
 */
function ua(): string {
  return typeof navigator !== 'undefined' ? navigator.userAgent : '';
}

export function isIOS(): boolean {
  // 아이패드OS는 데스크톱 사파리로 위장하기도 해서 터치 포인트도 함께 본다.
  return (
    /iPad|iPhone|iPod/.test(ua()) ||
    (typeof navigator !== 'undefined' &&
      navigator.platform === 'MacIntel' &&
      (navigator as unknown as { maxTouchPoints?: number }).maxTouchPoints! > 1)
  );
}

export function isAndroid(): boolean {
  return /Android/.test(ua());
}

export function isMobile(): boolean {
  return isIOS() || isAndroid();
}

/** 이미 홈 화면 앱(PWA)으로 실행 중인가. */
export function isStandalone(): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia?.('(display-mode: standalone)').matches ||
    (navigator as unknown as { standalone?: boolean }).standalone === true
  );
}

/** 브라우저/OS에서 사람이 알아볼 짧은 기기 라벨을 유추한다(완벽할 필요 없음). */
export function deviceHint(): string {
  const u = ua();
  const os = /iPhone|iPad/.test(u)
    ? 'iPhone'
    : /Macintosh/.test(u)
      ? 'Mac'
      : /Android/.test(u)
        ? 'Android'
        : /Windows/.test(u)
          ? 'Windows'
          : '기기';
  const browser = /Edg\//.test(u)
    ? 'Edge'
    : /Chrome\//.test(u)
      ? 'Chrome'
      : /Safari\//.test(u)
        ? 'Safari'
        : /Firefox\//.test(u)
          ? 'Firefox'
          : '';
  return browser ? `${os} · ${browser}` : os;
}

/**
 * 카톡·네이버앱·인스타·페북·라인 등 **인앱 브라우저(웹뷰)** 인가.
 * 안드로이드 웹뷰는 UA에 `; wv)`가 들어간다.
 */
export function isInAppBrowser(): boolean {
  return /KAKAOTALK|NAVER|Instagram|FBAN|FBAV|FB_IAB|Line\/|Snapchat|Band|DaumApps|; wv\)/i.test(
    ua(),
  );
}

/** 카톡 인앱 브라우저인가(안내 문구를 카톡에 맞춰 쓸 때). */
export function isKakaoInApp(): boolean {
  return /KAKAOTALK/i.test(ua());
}

/**
 * 카톡 인앱 브라우저에서 현재 페이지를 **기본(외부) 브라우저**로 연다.
 * 카카오 공식 스킴(`kakaotalk://web/openExternal`)이라 카톡 안에서만 동작한다.
 * 다른 인앱(네이버·인스타 등)은 강제 열기 API가 없어 텍스트 안내로 폴백한다.
 * ?ref= 같은 쿼리까지 그대로 넘기려고 origin이 아니라 href 전체를 쓴다.
 */
export function openInExternalBrowser(): void {
  if (typeof window === 'undefined') return;
  window.location.href = `kakaotalk://web/openExternal?url=${encodeURIComponent(
    window.location.href,
  )}`;
}
